import React from "react";
import Button from "../components/Button";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router";
import { renderStrapiContent } from "../utils/contentfulOptions";
import StrapiImage from "../components/StrapiImage";
import FullPageLoader from "../components/FullPageLoader";

const WineStaticPage = (props) => {
  const history = useHistory();
  const info = props.wine;

  const renderGrape = () => (
    <>
      <h2>the grape</h2>
      {renderStrapiContent(info.the_grape)}
    </>
  );
  const renderWine = () => (
    <>
      <h2>the wine</h2>
      {renderStrapiContent(info.the_wine)}
    </>
  );
  const renderName = () => (
    <>
      <h2>the name</h2>
      {renderStrapiContent(info.the_name)}
    </>
  );

  if (!info) {
    return <FullPageLoader />;
  }

  const art = StrapiImage(info.wine_art);

  return (
    <div className="container content-page wine-static-page p-t-100">
      <button
        type="button"
        className="back-to-our-wines"
        onClick={() => history.push("/our-wines")}
      >
        <svg
          className="back-to-our-wines__arrow"
          viewBox="0 0 24 24"
          width="18"
          height="18"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <line x1="19" y1="12" x2="5" y2="12" />
          <polyline points="12 19 5 12 12 5" />
        </svg>
        <span>
          Back to <span className="fw-bold">Our Wines</span>
        </span>
      </button>

      <section className="content-hero">
        <p className="content-hero__kicker">Our wines</p>
        <h1 className="huge-text-no-quote content-hero__title">
          {info.wine_name}
        </h1>
        {info.description && (
          <p className="content-hero__intro">{info.description}</p>
        )}
        {info.keywords?.length > 0 && (
          <p className="content-list__author m-t-12">
            Keywords: {info.keywords.map((x) => x).join(", ")}
          </p>
        )}
        <Button
          className="m-t-20"
          type="secondary"
          external
          href="https://auburn-road-vineyard-winery-enoteca.square.site/"
        >
          Buy now
        </Button>
      </section>

      <section className="content-story">
        {art && (
          <div className="content-story__media">
            <img
              className="content-story__photo"
              src={art}
              alt={info.wine_name}
            />
          </div>
        )}
        <div className="content-story__copy gen-info">
          {info.the_grape && <div className="m-b-40">{renderGrape()}</div>}
          {info.the_wine && <div className="m-b-40">{renderWine()}</div>}
          {info.the_name && <div className="m-b-40">{renderName()}</div>}
          {info.playlist && (
            <div className="content-playlist">
              <h2>Playlist</h2>
              <div dangerouslySetInnerHTML={{ __html: info.playlist }} />
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default withRouter(WineStaticPage);
